module.exports = __webpack_public_path__ + "images/exclusive-62486ebeaca81a7e80772798e8237867.png";